import { render, staticRenderFns } from "./PageView.vue?vue&type=template&id=8cbb507e"
import script from "./PageView.vue?vue&type=script&lang=ts"
export * from "./PageView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports